import React from 'react'
import {connect} from 'react-redux'
import {Chart} from 'react-google-charts';
import {formatarReal} from '../../util/numberUtil';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export class GraficoPorRotas extends React.Component {


    tooltip(item) {
        return '<div class="google-visualization-tooltip-item"><strong style="font-size: 16px";">' + capitalizarTodasPrimeirasLetras(item.nome) + '</strong><br/>' +
            '<span style="font-size: 16px"> (Representa=):  <strong>' + item.porcentagemVendas + '%</strong></span><br/>' +
            '<span style="font-size: 16px"> (Q.Aprov=):  <strong>' + item.quantidadeVendas + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (Q.Canc =):  <strong>' + item.quantidadeCancelamentos + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (T.Faturado=):  <strong>' + formatarReal(item.valorTotalVendas.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (V.Cancelado=):  <strong>' + formatarReal(item.valorTotalCancelamentos.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (F.Liquid R$=):  <strong>' + formatarReal(item.valorTotalVendasLiquido.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (I.liquid R$=):  <strong>' + formatarReal(item.valorTotalImposto.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (L. Comissão=):  <strong>' + formatarReal(item.valorTotalComissao.toString()) + '</strong></span></div>'

    }
    
    executarDownload(arquivo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        a.download = 'VexBi - Faturamento por Rota.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    exportarGrafitoPorRotas() {
        let arquivo = 'Rota;Q. Aprov;Q. Cancelada;T. Faturado;V. Cancelado;F. Liquido; Imposto Líquido; L. Comissão\n';
        
        let retorno = this.props.vexadoBI.totalFaturamentoPorRota

        arquivo = `${arquivo}${retorno.map(it => {
            const valorTotalVendas = it.valorTotalVendas.toString().replace('.', ',')
            const valorTotalCancelamentos = it.valorTotalCancelamentos.toString().replace('.', ',')
            const valorTotalVendasLiquido = it.valorTotalVendasLiquido.toString().replace('.', ',')
            const valorTotalImposto = it.valorTotalImposto.toString().replace('.', ',')
            const valorTotalComissao = it.valorTotalComissao.toString().replace('.', ',')

            let valor = `${it.nome};${it.quantidadeVendas};"${it.quantidadeCancelamentos}";"${valorTotalVendas}";"${valorTotalCancelamentos}";"${valorTotalVendasLiquido}";"${valorTotalImposto}";"${valorTotalComissao}"`
            return valor;
        }).join('\n')}\n`;

        this.executarDownload(arquivo)
    }

    render() {
        const retorno = [];
        retorno.push(['Rota', 'Valor', {
            role: 'tooltip',
            type: 'string',
            p: {html: true}
        }]);
        this.props.vexadoBI.totalFaturamentoPorRota.forEach((it) => retorno.push([capitalizarTodasPrimeirasLetras(it.nome), it.porcentagemVendas, this.tooltip(it)]));

        return <React.Fragment>
            <Chart
                chartType="PieChart"
                data={retorno}
                options={{
                    title: 'Faturamento por rota',
                    tooltip: {trigger: 'selection', isHtml: true},
                }}
                width={'100%'}
                height={this.props.full ? '800px' : '400px'}
                chartEvents={[
                    {
                        eventName: 'ready',
                        callback: ({chartWrapper, google}) => {
                            const chart = chartWrapper.getChart();
                            google.visualization.events.addListener(chart, 'onmouseover', function (entry) {
                                chart.setSelection([{row: entry.row}]);
                            });

                            google.visualization.events.addListener(chart, 'onmouseout', function () {
                                chart.setSelection([]);
                            });
                        }
                    }
                ]}
            />
            {this.props.full ? null : <button className="input-group-text bg-white btn-campo-busca float-right"
                                            onClick={() => this.props.expandir('rota')}>Expandir</button>}
            {this.props.full ? null : <button className="input-group-text btn-laranja btn-campo-busca float-right exportar"
                                            onClick={() => this.exportarGrafitoPorRotas()}>Exportar Lista</button>}    
        </React.Fragment>
    }
}

export function mapStateToProps(state) {
    return {
        vexadoBI: state.vexadoBI
    }
}

export default connect(mapStateToProps, {})(GraficoPorRotas)
